import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import MarkdownIt from 'markdown-it'
import markdownItLazyHeaders from 'markdown-it-lazy-headers'
import styles, { previewTheme } from './styles'

// FORKS: MarkdownMentionsRenderer

class MarkdownRenderer extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    md: null,
  }

  componentDidMount() {
    const md = new MarkdownIt({ linkify: true, breaks: true })
    md.use(markdownItLazyHeaders)

    // Redefine hyperlink renderer to always open links in a separate tab to avoid the user navigating away
    const linkRenderer = md.renderer.rules.link_open || this.defaultRenderer
    md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
      tokens[idx].attrPush(['target', '_blank'])
      return linkRenderer(tokens, idx, options, env, self)
    }

    this.setState({ md })
  }

  // eslint-disable-next-line class-methods-use-this
  defaultRenderer = (tokens, idx, options, _, self) => self.renderToken(tokens, idx, options)

  render() {
    const { md } = this.state
    const content = md && this.props.source ? md.render(this.props.source) : ''

    return (
      <div
        className={cx(styles.preview, this.props.className, previewTheme(this.props.theme))}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )
  }
}

MarkdownRenderer.propTypes = {
  source: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  className: PropTypes.string,
}

MarkdownRenderer.defaultProps = {
  theme: 'primary',
  // eslint-disable-next-line react/default-props-match-prop-types
  source: '',
}

export default MarkdownRenderer
